/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ActivityDtoCreatedBy } from './ActivityDtoCreatedBy';
import {
    ActivityDtoCreatedByFromJSON,
    ActivityDtoCreatedByFromJSONTyped,
    ActivityDtoCreatedByToJSON,
} from './ActivityDtoCreatedBy';

/**
 * 
 * @export
 * @interface ActivityDto
 */
export interface ActivityDto {
    /**
     * The ID of the activity.
     * @type {number}
     * @memberof ActivityDto
     */
    id: number;
    /**
     * The key that identifies the type of the activity.
     * @type {string}
     * @memberof ActivityDto
     */
    key: string;
    /**
     * The already translated, human readable text of the activity.
     * @type {string}
     * @memberof ActivityDto
     */
    text: string;
    /**
     * The ID of the deployment the activity relates to, or null for team wide activities.
     * @type {number}
     * @memberof ActivityDto
     */
    deploymentId: number | null;
    /**
     * The date the activity has been logged.
     * @type {Date}
     * @memberof ActivityDto
     */
    createdAt: Date;
    /**
     * 
     * @type {ActivityDtoCreatedBy}
     * @memberof ActivityDto
     */
    createdBy: ActivityDtoCreatedBy | null;
}

/**
 * Check if a given object implements the ActivityDto interface.
 */
export function instanceOfActivityDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "key" in value;
    isInstance = isInstance && "text" in value;
    isInstance = isInstance && "deploymentId" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "createdBy" in value;

    return isInstance;
}

export function ActivityDtoFromJSON(json: any): ActivityDto {
    return ActivityDtoFromJSONTyped(json, false);
}

export function ActivityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'key': json['key'],
        'text': json['text'],
        'deploymentId': json['deploymentId'],
        'createdAt': (new Date(json['createdAt'])),
        'createdBy': ActivityDtoCreatedByFromJSON(json['createdBy']),
    };
}

export function ActivityDtoToJSON(value?: ActivityDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'key': value.key,
        'text': value.text,
        'deploymentId': value.deploymentId,
        'createdAt': (value.createdAt.toISOString()),
        'createdBy': ActivityDtoCreatedByToJSON(value.createdBy),
    };
}

